import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "@bellomyinsightstech/app-shell/tokens.css";
import "@bellomyinsightstech/app-shell/styles.css";
import "./styles.css";
import "./components/analytics/analytics.css";
import "./components/analytics/crosstabs/CrosstabShared.css";
import { AuthProvider } from "./state/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
